<template>
    <section class="tasks"
             v-bind:class="{ 'h-100': isKanban }">
        <task-title></task-title>
        <router-view></router-view>
    </section>
</template>

<script>
import TaskTitle from "../components/Tasks/TaskTitle";
export default {
    name: "Tasks",
    components: {
        TaskTitle,
    },
    data () {
        return {

        };
    },
    computed: {
        isKanban () {
            return this.$route.path.includes("/tasks/kanban");
        },
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.tasks {

}
</style>
